/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "./node_modules/modern-css-reset/dist/reset.min.css"
import "./src/static/css/boilerform.min.css"
// You can delete this file if you're not using it
